import {useEffect, useState} from 'react';
import ExternalAssetServiceAPI from '../../Service/AssetService/ExternalAssetServiceAPI';
import APIServer from '@taopix/taopix-core/dist/types/Service/APIServer';

const useExternalServiceAPI = (server: APIServer) => {
  const [api, setAPI] = useState<ExternalAssetServiceAPI>(new ExternalAssetServiceAPI(server));

  useEffect(() => {
    setAPI(new ExternalAssetServiceAPI(server));
  }, [server]);

  return api;
};

export default useExternalServiceAPI;
